import { createAction as makeActionCreator } from 'redux-actions';
import moment from 'moment';
import api from '../api/';
import { selectedOptionsChanged } from './booking';
import { handleError } from './errors';

export const ticketsLoading = makeActionCreator('TICKETS_LOADING');
export const ticketsLoaded = makeActionCreator('TICKETS_LOADED');
export const ticketSelected = makeActionCreator('TICKET_SELECTED');
export const ticketFailed = makeActionCreator('TICKET_FAILED');

export const getTickets = dispatch => () => {
  dispatch(ticketsLoading());
  api.requestTickets()
    .then((tickets) => {
      dispatch(ticketsLoaded(tickets));
    })
    .catch((error) => {
      dispatch(ticketFailed());
      dispatch(handleError)(error);
    });
};

export const selectTicket = dispatch => (ticket) => {
  const activationDate = moment(ticket.activationDate, 'YYYY-MM-DD');
  const isActive = activationDate.isSameOrBefore(moment());
  if (!isActive) {
    return;
  }
  dispatch(selectedOptionsChanged([]));
  dispatch(ticketSelected(ticket));
};



// WEBPACK FOOTER //
// ./src/actions/ticket.js